/* ----------------------------------------------------------------- */
/* Text reveal — UI/UX refresh 2026                                  */
/* Splits headings into per-word spans, fades each word up with      */
/* stagger when scrolled into view. Pairs with `.text-reveal-*` CSS. */
/* Targets section titles + opt-in [data-text-reveal] elements.      */
/* Skips elements containing inline HTML (links, br, em) — too risky */
/* to split. Honours prefers-reduced-motion + Mojave .motion-reduce. */
/* ----------------------------------------------------------------- */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var SELECTORS = [
    '.featured-collection__title:not(.motion-reduce)',
    '.products-carousel__title:not(.motion-reduce)',
    '.page-banner__title',
    '.collection-banner__title',
    '[data-text-reveal]'
  ].join(',');

  function splitWords(el) {
    if (el.dataset.textRevealReady === '1') return false;
    // Skip if heading contains anything other than plain text (links, br, em, etc.)
    if (el.querySelector('a, br, em, strong, span, i, b')) return false;

    var text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return false;

    el.setAttribute('aria-label', text);
    el.innerHTML = '';
    var words = text.split(' ');

    words.forEach(function (word, i) {
      var outer = document.createElement('span');
      outer.className = 'text-reveal__word';
      outer.setAttribute('aria-hidden', 'true');

      var inner = document.createElement('span');
      inner.className = 'text-reveal__inner';
      inner.textContent = word;
      inner.style.transitionDelay = (i * 55) + 'ms';

      outer.appendChild(inner);
      el.appendChild(outer);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });

    el.dataset.textRevealReady = '1';
    el.classList.add('text-reveal-init');
    return true;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });

  function attach(el) {
    if (el.closest('.header, .footer, .modal, .cart-drawer, .swiper-slide')) return;
    if (!splitWords(el)) return;

    var rect = el.getBoundingClientRect();
    var inView = rect.top < window.innerHeight && rect.bottom > 0;

    if (inView) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.classList.add('is-revealed');
        });
      });
    } else {
      observer.observe(el);
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTORS).forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
